<template>
  <modal
    :name="name"
    :resizable="true"
    height="auto"
    :width="size.includes('px') || size.includes('%') ? size : size + '%'"
    :clickToClose="false"
    :scrollable="scrollable"
    v-on="$listeners"
  >
    <h2
      style="z-index:99"
      @click="closeModal()"
      v-if="close"
      class="position-absolute right-0 top-0 pt-3 pr-3"
    >
      <i class="icon-close cursor-pointer"></i>
    </h2>
    <slot></slot>
  </modal>
</template>
<script>
import $ from "jquery";
import Vue from "vue";

export default {
  props: {
    name: String,
    size: {
      type: String,
      default: "80"
    },
    close: {
      type: Boolean,
      default: true
    },
    scrollable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    showModal() {
      this.$modal.show(this.name);
    },
    closeModal() {
      this.$modal.hide(this.name);
      this.$emit("closeModal");
    }
  }
};
</script>
<style scoped></style>
